import { Fragment } from 'react';

// Add line breaks after ". "
export function newLineAfterDotEndOfSentence(str: string) {
  return (
    <>
      {str.split('. ').map((sentence, index, arr) => {
        if (index === arr.length - 1) {
          return <span key={`sentence${index}`}>{sentence}</span>;
        }
        return (
          <Fragment key={`sentence${index}`}>
            <span>{sentence}.</span>
            <br />
          </Fragment>
        );
      })}
    </>
  );
}
